import { render } from "./DataCollection.vue?vue&type=template&id=5672dd6f&scoped=true"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"

import "./DataCollection.vue?vue&type=style&index=0&id=5672dd6f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5672dd6f"]])

export default __exports__